<template>
  <div class="exchange__content">
    <h1 class="exchange__content__title">Exchange</h1>
    <div class="exchange__currency">
      <div class="exchange__currency__item">
        <div class="exchange__currency__choice">
          <div
            class="exchange__currency__select"
            :class="{ disableSelect: disableSelect }"
            @click="showGiveCurrencyMenu = !showGiveCurrencyMenu"
          >
            <span>{{ currencyGive.toUpperCase() }}</span>
            <img
              :class="{ rotate: showGiveCurrencyMenu }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="exchange__currency__menu" v-show="showGiveCurrencyMenu">
            <p v-if="currencyGive !== 'usd'" @click="selectGiveCurrency('usd')">USD</p>
            <p v-if="currencyGive !== 'eur'" @click="selectGiveCurrency('eur')">EUR</p>
            <p v-if="currencyGive !== 'rub'" @click="selectGiveCurrency('rub')">RUB</p>
          </div>
        </div>
        <div class="exchange__currency__input__wrapper" :class="{ disable: disableSelect }">
          <input
            v-model="amountGive"
            type="number"
            placeholder="Enter the amount to exchange:"
            @input="calculateGotCurrency"
          />
        </div>
      </div>
      <div class="exchange__currency__item">
        <div class="exchange__currency__choice">
          <div
            class="exchange__currency__select"
            :class="{ disableSelect: disableSelect }"
            @click="showGotCurrencyMenu = !showGotCurrencyMenu"
          >
            <span>{{ currencyGot.toUpperCase() }}</span>
            <img
              :class="{ rotate: showGotCurrencyMenu }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="exchange__currency__menu" v-show="showGotCurrencyMenu">
            <p
              v-if="currencyGive !== 'usd' && currencyGot !== 'usd'"
              @click="selectGotCurrency('usd')"
            >
              USD
            </p>
            <p
              v-if="currencyGive !== 'eur' && currencyGot !== 'eur'"
              @click="selectGotCurrency('eur')"
            >
              EUR
            </p>
            <p
              v-if="currencyGive !== 'rub' && currencyGot !== 'rub'"
              @click="selectGotCurrency('rub')"
            >
              RUB
            </p>
          </div>
        </div>
        <div class="exchange__currency__input__wrapper" :class="{ disable: !Number(amountGive) }">
          <input type="number" disabled placeholder="Amount after exchange" v-model="amountGot" />
        </div>
      </div>
      <div class="exchange__currency__input__wrapper disable">
        <input type="number" placeholder="Two-factor" v-model="twoFactor" />
      </div>
      <div class="exchange__currency__rate">
        <p>Currency exchange rate:</p>
        <span>{{ currentRate[0] }}&nbsp; - &nbsp;{{ currentRate[1] }}</span>
      </div>
      <div class="exchange__currency__btn">
        <button
          :class="{ disable: !twoFactor || !Number(amountGive) || disableBtn }"
          @click="exchangeCurrency"
        >
          Exchange
        </button>
        <p v-if="exchangeSuccess" class="exchange__success">Success</p>
        <p v-if="exchangeError" class="exchange__error">Error</p>
      </div>
    </div>
    <div class="exchange__rates">
      <h2>Currency exchange rates:</h2>
      <Loader v-if="loader" />
      <table class="exchange__rates__table" v-if="!loader">
        <thead>
          <tr>
            <th>Currency</th>
            <th>Buying</th>
            <th>Sale</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in allRates" :key="index">
            <td>{{ index }}</td>
            <td>{{ isNumber(item[0]) }} {{ currencyMap[isCurrency] }}</td>
            <td>{{ isNumber(item[1]) }} {{ currencyMap[isCurrency] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import './exchange.scss'

import http from '../../utils/http'
import cookie from 'vue-cookie'
import Loader from '../../components/Loader/Loader'

export default {
  name: 'Exchange',
  components: {
    Loader
  },
  data() {
    return {
      showGiveCurrencyMenu: false,
      currencyGive: 'rub',
      showGotCurrencyMenu: false,
      currencyGot: 'eur',
      amountGive: null,
      amountGot: null,
      currentRate: [],
      twoFactor: null,
      disableSelect: false,
      exchangeSuccess: false,
      exchangeError: false,
      disableBtn: false,
      allRates: [],
      currencyMap: {
        rub: '₽',
        usd: '$',
        eur: '€'
      },
      loader: true
    }
  },
  computed: {
    isCurrency() {
      return this.$store.state.currency
    }
  },
  mounted() {
    this.gotCurrencyRate()
    this.getAllRates()
  },
  created() {
    this.initListeners()
  },
  destroyed() {
    this.initListeners()
  },
  watch: {
    isCurrency: function () {
      this.getAllRates()
    }
  },
  methods: {
    selectGiveCurrency(currency) {
      this.currencyGive = currency
      this.showGiveCurrencyMenu = false
      if (this.currencyGive === this.currencyGot) {
        switch (this.currencyGot) {
          case 'rub':
            this.currencyGot = 'usd'
            break
          case 'eur':
            this.currencyGot = 'rub'
            break
          case 'usd':
            this.currencyGot = 'rub'
        }
      }
      this.gotCurrencyRate()
      this.amountGive = 0
      this.amountGot = null
    },
    selectGotCurrency(currency) {
      this.currencyGot = currency
      this.showGotCurrencyMenu = false
      this.gotCurrencyRate()
      this.amountGive = 0
      this.amountGot = null
    },
    calculateGotCurrency() {
      this.amountGot = (this.amountGive / this.currentRate[1].split(':')[1].trim()).toFixed(4)
    },
    gotCurrencyRate() {
      this.disableSelect = true
      this.currentRate = []
      fetch(
        `https://payments.neuralgeneration.com/api/v1/special/convert_rate?from_currency=${this.currencyGive}&to_currency=${this.currencyGot}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          for (const [key, value] of Object.entries(data)) {
            this.currentRate.push(`${key}: ${value}`)
          }
          this.disableSelect = false
        })
    },
    changeCurrency() {
      fetch(
        `https://payments.neuralgeneration.com/api/v1/special/gm_balance?currency=${this.isCurrency}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          const balance = data.balance
          this.$store.commit('setBalance', balance)
        })
    },
    async exchangeCurrency() {
      this.disableBtn = true
      this.disableSelect = true
      const response = await http.post(
        `https://payments.neuralgeneration.com/api/v1/special/gm_convert`,
        {
          from_currency: this.currencyGive,
          to_currency: this.currencyGot,
          amount: Number(this.amountGive),
          topt: this.twoFactor
        },
        cookie.get('token')
      )
      if (response.statusCode === 200) {
        this.exchangeSuccess = true
        this.amountGive = 0
        this.amountGot = null
        this.twoFactor = null
        setTimeout(() => {
          this.exchangeSuccess = false
          this.changeCurrency()
        }, 2000)
      } else {
        this.exchangeError = true
        this.amountGive = 0
        this.twoFactor = null
        this.amountGot = null
        setTimeout(() => {
          this.exchangeError = false
        }, 2000)
      }
      this.disableBtn = false
      this.disableSelect = false
    },
    getAllRates() {
      this.loader = true
      fetch(
        `https://payments.neuralgeneration.com/api/v1/special/exchange_rates?currency=${this.isCurrency}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          this.allRates = Object.entries(data).reduce((prev, current) => {
            const currency = current[0].split('-')
            const valueCurrency = current[1]
            if (currency[0].toLowerCase() === this.isCurrency) {
              if (prev.hasOwnProperty(currency[1])) {
                prev[currency[1]][0] = valueCurrency
              } else {
                prev[currency[1]] = []
                prev[currency[1]][0] = valueCurrency
              }
            } else {
              if (prev.hasOwnProperty(currency[0])) {
                prev[currency[0]][1] = valueCurrency
              } else {
                prev[currency[0]] = []
                prev[currency[0]][1] = valueCurrency
              }
            }
            return prev
          }, {})
          for (const [key] of Object.entries(this.allRates)) {
            if (key === 'ETH' || key === 'BTC') {
              this.allRates[key][0] = (
                Math.round(this.allRates[key][0] * Math.pow(10, 6)) + ''
              ).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
              this.allRates[key][1] = (
                Math.round(this.allRates[key][1] * Math.pow(10, 6)) + ''
              ).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
            }
          }
          this.loader = false
        })
    },
    isNumber(item) {
      if (Number(item)) {
        return item.toFixed(3)
      } else return item
    },
    closeByClickingSelect(event) {
      const path = event.path || (event.composedPath && event.composedPath())
      if (
        event &&
        !path.find((div) => div.classList && div.classList.contains('exchange__currency__select'))
      ) {
        this.showGiveCurrencyMenu = false
        this.showGotCurrencyMenu = false
      }
    },
    initListeners() {
      document.addEventListener('click', this.closeByClickingSelect)
    }
  }
}
</script>
